<script>
import IconX from "@js/components/Icons/IconX.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import DraggableComponent from "@js/components/Dragable/DraggableComponent.vue";
import {ref} from "vue";

export default {
    name: "CatalogSelectedFilterTags",
    components: {DraggableComponent, IconX},
    setup() {
        const catalogStore = useCatalogStore()
        const visibleTagsLimit = 3
        const showAllTags = ref(false)

        const toggleShowAllTags = () => {
            showAllTags.value = !showAllTags.value
        };

        return {
            catalogStore,
            visibleTagsLimit,
            showAllTags,
            toggleShowAllTags,
        };
    },
};
</script>

<template>
    <template v-if="catalogStore.selected_filters.length">
        <div v-for="(tag, index) in catalogStore.selected_filters" :key="tag.value">
            <div v-if="showAllTags || index < visibleTagsLimit"
                 :class="{'ms-2': index === 0 }" @click="catalogStore.removeFilter(tag)"
                 class="group flex items-center cursor-pointer bg-gray-300 md:hover:bg-indigo-600 md:hover:text-white transition rounded-full me-2 my-2">
                <div class="font-semibold text-xs text-nowrap py-2 ps-4 pe-2">
                    {{ tag.title }}
                </div>
                <div class="group-hover:bg-black/50 rounded-full h-full p-2 transition">
                    <IconX class="group-hover:stroke-white second:hover:stroke-black w-3.5 h-3.5 transition"/>
                </div>
            </div>
        </div>

        <!-- Кнопка "Еще" для показа оставшихся тегов -->
        <div v-if="catalogStore.selected_filters.length > visibleTagsLimit"
             @click="toggleShowAllTags"
             class="text-xs text-nowrap font-semibold cursor-pointer py-2 px-4 my-2 rounded-full bg-gray-300 md:hover:bg-indigo-600 md:hover:text-white">
            {{ showAllTags ? 'Скрыть' : `Еще (${catalogStore.selected_filters.length - visibleTagsLimit})` }}
        </div>
    </template>
</template>

<style scoped lang="scss">
</style>
